var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-right":"20px"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.handleClick}},[_c('span',[_c('i',{staticClass:"fe fe-plus-circle"})]),_vm._v(" "+_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }